export default __webpack_public_path__ + "static/media/entertainment.961d1dc4.jpg";